import ChartVerticalIcon from './ChartVertical'
import LanguageIcon from './Language'
import EmptyHotCategoryIcon from './EmptyHotCategory'
import LawyerIcon from './Lawyer'

const AccountCenter = {
    ChartVerticalIcon,
    LanguageIcon,
    EmptyHotCategoryIcon,
    LawyerIcon
}

export default AccountCenter
